import React, { useEffect, useState } from 'react'
// import Header from '@/components/header'
import { Bscroll } from '@/components/bscroll'
import { createNonceStr, md5, getLocationSearch,getWeekData } from '@/utils/utils'
import { CashRuleApi } from '@/api'
import request from '@/utils/request'
import './index.scss'
const WithdrawalRules = () => {
  //获取token
  let getToken = getLocationSearch().token
  //响应式数据
  //冻结天数
  // let [frozenInDay,setfrozenInDay] = useState();
  // //超过时长（小时）
  // let [orderTimePass,setorderTimePass] = useState();
  //提现规则
  let [ruleType,setruleType] = useState();
  //日期
  let [weekendVal,setweekendVal] = useState('');
  // 开始时间
  let [startTime,setStartTime] = useState();
  // 结束时间
  let [endTime,setEndTime] = useState()
  // 最高限额
  let [maxLimit,setMaxLimit] = useState()
  //获取数据
  useEffect(() => {
    
    //带Token签名
    let appKey = 'app_h5';
    let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let token = getToken
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    request.get(CashRuleApi, {
      token: token,
    }, {
      appKey: appKey,
      timestamp: timestamp,
      random: random,
      token: token,
      sign: sign
    })
      .then((data) => {
        if(data.data.errorCode === 0 && data.data.errorMsg === 'SUCCESS'){
          // setfrozenInDay(data.data.data.frozenInDay);
          // setorderTimePass(data.data.data.orderTimePass);
          setruleType(data.data.data.ruleType);
          setweekendVal(data.data.data.weekendVal);
          setStartTime(data.data.data.startTime);
          setEndTime(data.data.data.endTime);
          setMaxLimit(data.data.data.maxLimit);
        }
      })
    return () => {
    }
  }, [getToken])
  return (
    <div className="withdrawal-rules__box">
      {/* <Header tit='提现规则'></Header> */}
      <div className="withdrawal-rules__show">
        <Bscroll scrollX={false} scrollY={true}>
          <div className="withdrawal-rules__list">
            <div className="rules__con">
              <p className="rules_q">
                <span>我什么时候可以提现？</span>
                <em>Q</em>
              </p>
              <p className="rules_a">
                <em>A</em>
                <span>{ruleType === 1 ? `司机每天${startTime || '00:00'}-${endTime || '00:00'}可以提现 `: `司机在${getWeekData(weekendVal)}的${startTime || '00:00'}-${endTime || '00:00'}可以提现`}</span>
              </p>
            </div>
            {/* <div className="rules__con">
              <p className="rules_q">
                <span>可提现金额是如何计算的？</span>
                <em>Q</em>
              </p>
              <p className="rules_a">
                <em>A</em>
                <span>
                  {
                    ruleType === 1 ?
                    `可提现金额是在${frozenInDay || 0}个自然日之前的所有收入。比如你的账户余额有100元，其中30元是在${frozenInDay || 0}天前的收入，那么你在今天的可提现接就是30元。`:
                    `可提现金额是在${orderTimePass || 0}小时之前的所有收入。比如你的账户余额有100元，其中30元是在${orderTimePass || 0}小时前的收入，那么你在今天的可提现接就是30元。`
                  }
                </span>
              </p>
            </div> */}
            <div className="rules__con">
              <p className="rules_q">
                <span>我可以提现到别人的支付宝账户嘛？</span>
                <em>Q</em>
              </p>
              <p className="rules_a">
                <em>A</em>
                <span>不可以哦，只能提现到本人支付宝账户哦~</span>
              </p>
            </div>
            <div className="rules__con">
              <p className="rules_q">
                <span>我在提现日最高可提现多少钱？</span>
                <em>Q</em>
              </p>
              <p className="rules_a">
                <em>A</em>
                <span>司机在提现日的最高提现额度为{maxLimit || 0}元。</span>
              </p>
            </div>
          </div>
        </Bscroll>
      </div>
    </div>
  )
}
export default WithdrawalRules
